<nav class="navbar bg-body-tertiary">
  <div class="container-fluid">
    <a class="navbar-brand" href="#">{{tile.title}}</a>
    <div>
      @if(tile.showAdd) {
      <button kendoButton fillMode="flat" (click)="addItem(tile)">
        <fa-icon class="fa-solid fa-duotone" [icon]="['fad', 'plus']"></fa-icon>
        Add
      </button>
      }
      <kendo-dropdownbutton (itemClick)="onItemClick($event)" [data]="tile.menuContext"
        [popupSettings]="{ popupClass: popupClass, animate: true }"
        textField="text">
        <fa-icon class="fa-solid fa-duotone" [icon]="['fad', 'ellipsis-vertical']"></fa-icon>
      </kendo-dropdownbutton>
      <button kendoButton fillMode="flat" (click)="closeTile(tile)"> <fa-icon class="fa-solid fa-duotone"
          [icon]="['fad', 'xmark']"></fa-icon></button>
    </div>
  </div>
</nav>
